import React from 'react';
import { ViewerComponentProps } from '../types';
import { cn } from '@/common/utils';
import { FileQuestion } from 'lucide-react';

/**
 * Fallback viewer for unsupported file types
 */
export const UnsupportedViewer: React.FC<ViewerComponentProps> = ({
  fileUrl,
  fileName,
  className,
}) => {
  return (
    <div className={cn('flex flex-col w-full h-full bg-gray-50', className)}>
      <div className="flex-1 flex flex-col items-center justify-center p-8 text-center">
        <FileQuestion className="w-16 h-16 text-gray-300 mb-4" />
        <h3 className="font-semibold text-gray-700 mb-2">
          Preview not available
        </h3>
        <p className="text-sm text-gray-500 mb-1">
          This file type is not supported for preview
        </p>
        {fileName && (
          <p className="text-xs text-gray-400 mt-2 font-mono break-all px-4">
            {fileName}
          </p>
        )}
      </div>
    </div>
  );
};

/**
 * Matcher function for registry
 * Always matches - this is the fallback viewer (lowest priority)
 */
export const unsupportedMatcher = (): boolean => {
  return true;
};
